import binIcon from '../assets/bin.svg';

function DeleteIconButton({ onClick, title = 'Delete', disabled = false, className = '' }) {
  return (
    <button
      type="button"
      className={`modern-icon-button modern-icon-button-danger${className ? ` ${className}` : ''}`}
      onClick={onClick}
      title={title}
      aria-label={title}
      disabled={disabled}
    >
      <img src={binIcon} alt="" aria-hidden="true" />
    </button>
  );
}

export default DeleteIconButton;
